module.exports = __webpack_public_path__ + "static/media/currency-symbol.012db661.png";